import { createEvent, createStore } from 'effector';
import { createInstrumentFx } from '../../entities/instrument';
import { ApiError } from '../../shared/api/client';

export const addInstrumentOpened = createEvent();
export const closed = createEvent();
export const $open = createStore(false)
  .on(addInstrumentOpened, () => true)
  .reset(closed, createInstrumentFx.done);
export const $errors = createStore<Record<string, string>>({})
  .on(createInstrumentFx.failData, (_, error) => (error instanceof ApiError ? error.fields : {}))
  .reset(addInstrumentOpened);
export const $formError = createStore<string | null>(null)
  .on(createInstrumentFx.failData, (_, error) =>
    error instanceof ApiError && Object.keys(error.fields).length > 0 ? null : error.message,
  )
  .reset(addInstrumentOpened);
